import { call, takeLatest } from 'redux-saga/effects';

import * as constants from './chart.constants';
import * as services from './chart.saga-services';
import * as types from './chart.types';

function* invokeInitialChartPage() {
  yield call(services.initialChartPage);
}

function* invokeInitialChartEditPage() {
  yield call(services.initialChartEditPage);
}

function* invokeSelectChartVersion(action: types.ISelectChartVersion) {
  yield call(services.selectChartVersion, action.payload);
}

function* invokeSelectChartDraft() {
  yield call(services.selectChartDraft);
}

function* invokePublishChartVersion() {
  yield call(services.publishSelectedChartVersion);
}

function* invokePublishChartDraft() {
  yield call(services.publishSelectedChartDraft);
}

function* invokeCreateEmptyChartDraft() {
  yield call(services.createEmptyChartDraft);
}

function* invokeCreateDraftFromVersion() {
  yield call(services.createDraftFromVersion);
}

function* invokeDeleteChart(action: types.IDeleteChart) {
  yield call(services.deleteChart, action.payload);
}

export function* watchChartPageSaga() {
  yield takeLatest(constants.INITIAL_CHART_PAGE, invokeInitialChartPage);
  yield takeLatest(constants.INITIAL_CHART_EDIT_PAGE, invokeInitialChartEditPage);
  yield takeLatest(constants.SELECT_CHART_VERSION, invokeSelectChartVersion);
  yield takeLatest(constants.SELECT_CHART_DRAFT, invokeSelectChartDraft);
  yield takeLatest(constants.PUBLISH_CHART_VERSION, invokePublishChartVersion);
  yield takeLatest(constants.PUBLISH_CHART_DRAFT, invokePublishChartDraft);
  yield takeLatest(constants.CREATE_EMPTY_CHART_DRAFT, invokeCreateEmptyChartDraft);
  yield takeLatest(constants.CREATE_DRAFT_FROM_VERSION, invokeCreateDraftFromVersion);
  yield takeLatest(constants.DELETE_CHART, invokeDeleteChart);
}
